module.exports = __webpack_public_path__ + "static/media/other.d06c3629.png";